import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, finalize, mergeMap, take } from 'rxjs/operators';

import { AuthService } from '@app/auth/auth.service';
import { TokenService } from '@app/auth/token.service';

import { SuccessTokenRefresh } from '../authentication';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  refreshToken$ = new Subject<SuccessTokenRefresh>();
  isRefreshing = false;

  constructor(
    private authService: AuthService,
    private tokenService: TokenService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    request = request.clone({});
    return next.handle(request).pipe(
      catchError((error) => {
        if (error.status === 401) {
          if (!this.isRefreshing) {
            this.isRefreshing = true;
            this.authService
              .refreshToken()
              .pipe(take(1))
              .subscribe((tokens: SuccessTokenRefresh) =>
                this.refreshToken$.next(tokens)
              );
          }
          return this.waitUntilRefreshes(request, next);
        } else {
          return throwError(() => error);
        }
      })
    );
  }

  public waitUntilRefreshes(request: HttpRequest<any>, next: HttpHandler) {
    return this.refreshToken$.pipe(
      take(1),
      mergeMap(() => {
        request = request.clone({
          setHeaders: {
            authorization: this.tokenService.getTokenWithPrefix(request.url)
          }
        });
        return next.handle(request);
      }),
      finalize(() => {
        this.isRefreshing = false;
      })
    );
  }
}
